import React from 'react';
import * as S from './styles';

export type Props = {
  ariaLabel?: string;
  to?: string | null;
  isExternal?: boolean;
  className?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  containerProps?: Record<string, any>;
} & Pick<React.ComponentProps<'a'>, 'rel' | 'target'>;

export const Clickable = ({
  to,
  isExternal,
  disabled,
  containerProps,
  ...props
}: Props) => {
  if (!to) {
    return <S.Button disabled={disabled} {...props} {...containerProps} />;
  }

  return isExternal || disabled ? (
    <S.ExternalLink
      href={disabled ? undefined : to}
      {...props}
      {...containerProps}
    />
  ) : (
    <S.InternalLink
      to={to}
      {...props}
      {...containerProps}
      data-test={props['data-test'] || 'InternalLink'}
    />
  );
};
